import { useContext } from 'react';
import { UserContext } from './Components/UserContext';
const Logout = () => {
const {setUser} = useContext(UserContext);
  window.localStorage.clear();
    setUser(null);
    window.location.href = "/";
}
export default Logout


